export const name = 'siteExperimentsService' as const
